import React from 'react';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { APP_ENV } from 'appenv';

import XtraAppBar from 'components/appbar/XtraAppBar';
import BackgroundImg from 'assets/background.jpg';
import Background618Img from 'assets/background-618.png';

import DesktopLobbyView from './DesktopLobbyView';
import MobileLobbyView from './MobileLobbyView';

const backgroundImage = () => {
  switch (APP_ENV) {
    case 'polyu618_staging': case 'polyu618_production':
      return Background618Img;
    default:
      return BackgroundImg;
  }
};

const RootContainer = styled.div`
  height: 100%;
  overflow: hidden;
  background-color: #F0F1F2;

  @media (min-width: 960px) {
    background: url(${backgroundImage()});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1440px auto;
  }

  @media (min-width: 1440px), (min-height: 960px) {
    background-size: cover;
  }
`;

const PageContentContainer = styled.div`
  min-width: 100%;
  height: calc(100% - 67.73px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 959px) {
    height: 100%;
    padding-top: 56px;
  }
`;

const MainLobbyContainer = () => {
  const isDesktop = useMediaQuery('(min-width: 960px)');

  return (
    <RootContainer>
      <XtraAppBar />
      <PageContentContainer>
        {
          isDesktop ? (
            <DesktopLobbyView />
          ) : (
            <MobileLobbyView />
          )
        }
      </PageContentContainer>
    </RootContainer>
  );
};

export default MainLobbyContainer;
